<template>
	<div id="test">
		<div class="card direct-chat direct-chat-primary">
			<div class="card-header">
				<h3 class="card-title">Direct Chat</h3>
				<div class="card-tools">
					<span data-toggle="tooltip" title="3 New Messages" class="badge badge-primary">3</span>
					<button type="button" class="btn btn-tool" data-card-widget="collapse">
						<i class="fas fa-minus"></i>
					</button>
					<button type="button" class="btn btn-tool" data-toggle="tooltip" title="Contacts" data-widget="chat-pane-toggle">
						<i class="fas fa-comments"></i>
					</button>
					<button type="button" class="btn btn-tool" data-card-widget="remove">
						<i class="fas fa-times"></i>
					</button>
				</div>
			</div>

			<div class="card-body">
				<!-- Conversations are loaded here -->
				<div class="direct-chat-messages">
					<!-- Message. Default to the left -->
					<div class="direct-chat-msg">
						<div class="direct-chat-infos clearfix">
							<span class="direct-chat-name float-left">Alexander Pierce</span>
							<span class="direct-chat-timestamp float-right">23 Jan 2:00 pm</span>
						</div>
						<!-- /.direct-chat-infos -->
						<img class="direct-chat-img" src="/adminlte/dist/img/user1-128x128.jpg" alt="message user image">
						<!-- /.direct-chat-img -->
						<div class="direct-chat-text">
							Is this template really for free? That's unbelievable!
						</div>
					<!-- /.direct-chat-text -->
					</div>
					<!-- /.direct-chat-msg -->

					<!-- Message to the right -->
					<div class="direct-chat-msg right">
						<div class="direct-chat-infos clearfix">
							<span class="direct-chat-name float-right">Sarah Bullock</span>
							<span class="direct-chat-timestamp float-left">23 Jan 2:05 pm</span>
						</div>
						<!-- /.direct-chat-infos -->
						<img class="direct-chat-img" src="/adminlte/dist/img/user3-128x128.jpg" alt="message user image">
						<!-- /.direct-chat-img -->
						<div class="direct-chat-text">
							You better believe it!
						</div>
						<!-- /.direct-chat-text -->
					</div>
					<!-- /.direct-chat-msg -->

					<!-- Message. Default to the left -->
					<div class="direct-chat-msg">
						<div class="direct-chat-infos clearfix">
							<span class="direct-chat-name float-left">Alexander Pierce</span>
							<span class="direct-chat-timestamp float-right">23 Jan 5:37 pm</span>
						</div>
						<!-- /.direct-chat-infos -->
						<img class="direct-chat-img" src="/adminlte/dist/img/user1-128x128.jpg" alt="message user image">
						<!-- /.direct-chat-img -->
						<div class="direct-chat-text">
							Working with AdminLTE on a great new app! Wanna join?
						</div>
						<!-- /.direct-chat-text -->
					</div>
					<!-- /.direct-chat-msg -->

					<!-- Message to the right -->
					<div class="direct-chat-msg right">
						<div class="direct-chat-infos clearfix">
							<span class="direct-chat-name float-right">Sarah Bullock</span>
							<span class="direct-chat-timestamp float-left">23 Jan 6:10 pm</span>
						</div>
						<!-- /.direct-chat-infos -->
						<img class="direct-chat-img" src="/adminlte/dist/img/user3-128x128.jpg" alt="message user image">
						<!-- /.direct-chat-img -->
						<div class="direct-chat-text">
							I would love to.
						</div>
						<!-- /.direct-chat-text -->
					</div>
					<!-- /.direct-chat-msg -->
				</div>
			</div>
			<div class="card-footer">
				<form action="#" method="post">
					<div class="input-group">
						<input type="text" name="message" placeholder="Type Message ..." class="form-control">
						<span class="input-group-append">
							<button type="button" class="btn btn-primary">Send</button>
						</span>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
	name: 'Chat',
	data() {
		return {
		}
	},
	methods: {
		...mapMutations(['changeTitleModule', 'changeSubTitleModule']),
		initModule() {
			this.changeTitleModule('Modulo de Chat')
			this.changeSubTitleModule('')
		},
	},
	components: {
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style>
</style>